export default "__VITE_ASSET__$oaoVEeo__"